<template>
    <div class="search-item" @click.stop="() => {}">
        <label class="label" :title="label" v-if="label">{{ label }}</label>
        <input
            @input="handleInput"
            @blur="blur"
            @focus="focus"
            @keyup.delete="deleteVal"
            v-model.trim="inputVal"
            ref="input"
            type="text"
            :placeholder="cptPlaceholder"
            @keypress.enter="keypressEnter"
        />
        <ul
            class="options"
            v-show="expand && lists.length"
            @mousemove="stop = true"
            @mouseleave="stop = false"
        >
            <li
                v-for="(item, index) in lists"
                :key="index"
                :class="{ selected: inputVal === item }"
                @click="selectChange(item)"
            >
                {{ item }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    emits: ['keypress-enter'],
    props: {
        value: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        dataKey: {
            type: String
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            stop: false,
            isMatch: false,
            inputVal: this.value,
            lastMatchVal: '',
            expand: false,
            timer: null,
            lists: [],
            requestTimer: null,
            url: ''
        };
    },
    computed: {
        cptPlaceholder() {
            return this.placeholder || this.$t('md-team:md-team.pleaseType', {
                label: this.label
            });
        }
    },
    mounted() {
        window.addEventListener('click', this.clickCallBack, false);
    },
    beforeDestory() {
        window.removeEventListener('click', this.clickCallBack);
    },
    methods: {
        clickCallBack() {
            this.expand = false;
        },
        deleteVal() {
            if (!this.inputVal.length) {
                this.inputVal = this.lastMatchVal = '';
                this.isMatch = false;
            }
        },
        getValue() {
            return this.inputVal;
        },
        handleInput(e) {
            this.isMatch = false;
            this.expand = !!this.inputVal;
            // load options
            if (this.inputVal && this.inputVal !== this.lastMatchVal) {
                const delay = 300;
                if (this.requestTimer) {
                    clearTimeout(this.requestTimer); 
                }
                this.requestTimer = setTimeout(() => {
                    this.lastMatchVal = this.inputVal;
                    this.loadOptions();
                }, delay);
            }
        },
        loadOptions() {
            let filedName = this.dataKey
                ? this.dataKey.toLowerCase()
                : this.label.toLowerCase();
            this.axiosIns
                .get('/api-site/agent/field/match', {
                    params: {
                        filedName,
                        keyword: this.inputVal
                    }
                })
                .then(res => {
                    this.lists = res.data || [];
                });
        },
        selectChange(val) {
            if (this.inputVal == val) {
                this.lastMatchVal = this.inputVal;
                this.isMatch = false;
            } else {
                this.isMatch = true;
                this.lastMatchVal = this.inputVal = val;
            }
            this.expand = false;
            this.stop = false;
            this.$emit('keypress-enter');
        },
        focus() {
            this.expand = !!this.inputVal;
        },
        blur() {
            if (this.stop) {
                return; 
            }
            this.expand = false;
            this.timer = null;
            if (!this.isMatch && this.url) {
                this.inputVal = this.lastMatchVal; 
            }
            this.expand = false;
        },
        keypressEnter() {
            this.$emit('keypress-enter');
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
.search-item {
    width: 100%;
    display: inline-block;
    position: relative;
    .options {
        max-width: 100%;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        transform: translateY(calc(100% + 2px));
        max-height: 200px;
        box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
        border: solid 1px #ebecf1;
        z-index: 10;
        overflow-x: hidden;
        overflow-y: auto;
        li {
            height: 40px;
            line-height: 40px;
            font-family: var(--font-normal);
            font-size: 14px;
            color: #191919;
            background-color: #fff;
            padding: 0 10px;
            cursor: pointer;
            &:not(.selected):hover {
                background-color: #f6f7fb;
            }
            &.selected {
                color: var(--color-theme);
            }
            @include ellipsis();
        }
    }
    ::-webkit-input-placeholder {
        font-size: 14px;
        font-family: var(--font-normal);
        color: #a8a8a8;
    }
}
</style>
